import { firestore } from "@/lib/Firebase";
import { collection, query, where, limit , getDocs, doc, getDoc } from "firebase/firestore"
import { API } from "../Client";
import { Institution, InstitutionDto } from "./types";


export namespace InstituitionService {
  
/**
 * Returns an empty array of institutions.
 *
 * @returns {Promise<Institution[]>}
 */
  export const getInstitutions = async (): Promise<Institution[]> => {
    return []
  };

/**
 * Retrieves an institution by its domain.
 * @param {string} domain - The domain of the institution (e.g. marywood.edu)
 * @returns {Promise<Institution | undefined>} - A promise that resolves to an institution object if found, or undefined if not found.
 * @throws {Error} - If an institution is not found.
 */
  export const getInstitution = async (domain: string): Promise<Institution | undefined> => {
    try {
      const institutionsRef = collection(firestore, 'institutions')
      const q = query(institutionsRef, where('domains', 'array-contains', domain), limit(1))
      const querySnapshot = await getDocs(q);
      
      if(querySnapshot.empty) return undefined

      const institution = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))[0] as Institution
      
      return {
        ...institution
      }
    } catch (error) {
      throw new Error((error as Error).message);
    }
  };

  export const searchInstitution = async (searchQuery: string, { signal }): Promise<Institution[]> => {
    const { data } = await API.get<Institution[]>(`/education/institutions/name/${searchQuery}`, {
      signal
    })
    return data;
    
    // FIREBASE 
    // const institutionsRef = collection(firestore, 'institutions');
    
    // // Renomeie a variável para evitar conflito com a função query()
    // const q = query(
    //   institutionsRef, 
    //   where('name', '>=', searchQuery), 
    //   where('name', '<=', searchQuery + '\uf8ff')
    // );
    
    // const querySnapshot = await getDocs(q);
    
    // return querySnapshot.docs.map(doc => ({
    //   id: doc.id,
    //   ...doc.data()
    // } as Institution)); // Adicione type assertion se necessário
  };

  export const getIntitutionById = async (id: string): Promise<Institution | null> => {
    if (!id) return null;
    try {
      const docRef = doc(firestore, "institutions", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return {
          id: docSnap.id,
          ...docSnap.data(),
          countryCode: docSnap.data()?.alphaTwoCode
        } as Institution;
      } else {
        return null;
      }
    } catch (error) {
      throw new Error((error as Error).message);
    }
  };
}
